module.exports = __webpack_public_path__ + "static/img/service_zhuanlifuwu.01e2da48.png";